/* eslint-disable @repo/internal/react/require-jsdoc */
import React, { type ReactNode } from 'react';

import { Box, Inline, Stack, Text, xcss } from '@atlaskit/primitives';
import { useThemeObserver } from '@atlaskit/tokens';

import { BrandHeading } from '../brand-heading';
import { Image } from '../image';
import { PageContentContainer } from '../page-content-container';

const bannerContainerStyles = xcss({
	display: 'flex',
	justifyContent: 'center',

	width: '100%',
});

const backgroundColorStyles = xcss({
	backgroundColor: 'elevation.surface.sunken',
});

const bannerWidthStyles = xcss({
	maxWidth: '980px',
	width: '100%',
	flex: 1,
});

const contentContainerStyles = xcss({
	height: '100%',
	minHeight: '380px',
	paddingBlock: 'space.1000',
	flex: 1,
});

const imageContainerStyles = xcss({
	flex: 1,
});

export const Banner = ({
	title,
	description,
	image,
	hasBackgroundColor,
}: {
	title: string;
	description: string;
	image?: {
		light: string;
		dark: string;
	};
	hasBackgroundColor?: boolean;
}) => {
	const { colorMode = 'light' } = useThemeObserver();
	const src = colorMode === 'dark' ? image?.dark || '' : image?.light || '';

	return (
		<Box xcss={[bannerContainerStyles, hasBackgroundColor && backgroundColorStyles]}>
			<PageContentContainer>
				<Inline alignBlock="center" xcss={bannerWidthStyles}>
					<Inline xcss={contentContainerStyles} alignBlock="center" spread="space-between">
						<Stack space="space.100">
							<BrandHeading as="h1" size="xxlarge">
								{title}
							</BrandHeading>
							<Text size="large">{description}</Text>
						</Stack>
					</Inline>
					<ImageContainer>
						{image ? <Image src={src} alt={`Banner for ${title} page`} /> : <div></div>}
					</ImageContainer>
				</Inline>
			</PageContentContainer>
		</Box>
	);
};

const ImageContainer = ({ children }: { children: ReactNode }) => {
	return <Box xcss={imageContainerStyles}>{children}</Box>;
};
